// 10 columns - Material & Deductions
export const gridLayoutMaterialReconcilitation =
  'grid-cols-[2fr_1fr_70px_1fr_1fr_1fr_1fr_40px_40px_40px]';

// 8 columns - Freight
export const gridLayoutFreight =
  'grid-cols-[1fr_1fr_1fr_1fr_1fr_1fr_40px_40px]';
